import { render, staticRenderFns } from "./NsSepaForm.vue?vue&type=template&id=40a37bb7&scoped=true&"
import script from "./NsSepaForm.vue?vue&type=script&lang=js&"
export * from "./NsSepaForm.vue?vue&type=script&lang=js&"
import style0 from "./NsSepaForm.vue?vue&type=style&index=0&id=40a37bb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a37bb7",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40a37bb7')) {
      api.createRecord('40a37bb7', component.options)
    } else {
      api.reload('40a37bb7', component.options)
    }
    module.hot.accept("./NsSepaForm.vue?vue&type=template&id=40a37bb7&scoped=true&", function () {
      api.rerender('40a37bb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/payment/NsSepaForm.vue"
export default component.exports